import german from '@/assets/languages/german/index';
import english from '@/assets/languages/english/index';
import french from '@/assets/languages/french/index';

export const messages = {
    de: german,
    en: english,
    fr: french,
};
